import { createActions, handleActions } from 'redux-actions';

/**
 * アクションタイプ
 */
export const TYPES = {
  SET_SYSTEM_LOGIN: 'setSystemLogin',
  OPEN_POPUP: 'openPopup',
  CLOSE_POPUP: 'closePopup',
  SYSTEM_LOGIN_SUCCESS: 'systemLoginSuccess',
  SET_BUTTON_CHECKED: 'setButtonChecked',
  SET_POLICY_CONTENTS: 'setPolicyContents',
  SET_DISP_CONTENT: 'setDispContent',
  SET_SELF_AUTH: 'setSelfAuth',
};

/**
 * コンテンツ
 */
export const CONTENTS = {
  INIT: '',
  SELF_AUTH: 'selfAuth',
  PRIVACY_POLICY: 'privacyPolicy',
  NOT_AGREE: 'notAgree',
};

/**
 * 初期State
 */
export const INIT_STATE = {
  loginId: '',
  loginPass: '',
  isOpenPopup: false,
  popupTitle: '',
  popupContents: '',
  isCheck: false,
  isButtonActive: true,
  policyContents: '',
  dispContent: CONTENTS.INIT,
  selfAuth: {
    mailAddress: '',
    exec: false,
  },
};

/**
 * アクション定義
 */
export const loginActions = createActions({
  [TYPES.SET_SYSTEM_LOGIN]: (...args) => ({
    key: args[0],
    value: args[1],
  }),
  [TYPES.OPEN_POPUP]: (...args) => ({
    title: args[0],
    contents: args[1],
  }),
  [TYPES.CLOSE_POPUP]: (...args) => ({
    isCancel: args[0],
  }),
  [TYPES.SYSTEM_LOGIN_SUCCESS]: (...args) => ({}),
  [TYPES.SET_BUTTON_CHECKED]: (...args) => ({
    key: args[0],
    value: args[1],
  }),
  [TYPES.SET_DISP_CONTENT]: (...args) => ({
    content: args[0],
  }),
  [TYPES.SET_SELF_AUTH]: (...args) => ({
    selfAuth: args[0],
  }),
});

/**
 * Reducer定義
 */
export const loginReducer = handleActions(
  {
    [TYPES.SET_SYSTEM_LOGIN]: (state, action) => ({
      ...state,
      [action.payload.key]: action.payload.value,
    }),
    [TYPES.OPEN_POPUP]: (state, action) => ({
      ...state,
      isOpenPopup: true,
      popupTitle: action.payload.title,
      popupContents: action.payload.contents,
      dispContent: CONTENTS.PRIVACY_POLICY,
    }),
    [TYPES.CLOSE_POPUP]: (state, action) => ({
      ...state,
      isOpenPopup: false,
      dispContent: action.payload.isCancel ? CONTENTS.NOT_AGREE : CONTENTS.INIT,
    }),
    [TYPES.SYSTEM_LOGIN_SUCCESS]: (state, action) => ({
      ...INIT_STATE,
    }),
    [TYPES.SET_BUTTON_CHECKED]: (state, action) => ({
      ...state,
      [action.payload.key]: action.payload.value,
    }),
    [TYPES.SET_POLICY_CONTENTS]: (state, action) => ({
      ...state,
      policyContents: action.payload.policyContents,
    }),
    [TYPES.SET_DISP_CONTENT]: (state, action) => ({
      ...state,
      dispContent: action.payload.content,
    }),
    [TYPES.SET_SELF_AUTH]: (state, action) => ({
      ...state,
      selfAuth: action.payload.selfAuth,
    }),
  },
  INIT_STATE,
);
